import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

class InstallationServiceSearchButtonAndPdfButton extends React.Component {
  render() {
    const {
      isAdmin,
      translate,
      dataConfirmation,
      shipmentNumber,
      shipmentRequestLoading,
      isEditState,
      downloadPDF,
      pdfName,
    } = this.props;
    const searchBtnTitle = shipmentRequestLoading
      ? translate('service_installation.loading')
      : translate('service_installation.search');

    const pdfDownloadBtnTitle = translate('service_report.column_task.downloadPDF');
    return (
      <span style={{ position: 'relative', left: '-10px' }}>
        <button type="button"
                className="shipment-button form-button form-input-shadow"
                onClick={() => {
                  dataConfirmation(shipmentNumber);
                }}
                disabled={isEditState || shipmentRequestLoading || shipmentNumber === ''}>
          {shipmentRequestLoading && (
            <i className="fa fa-refresh fa-spin"
               style={{ marginRight: '5px' }} />
          )}
          <span>{searchBtnTitle}</span>
        </button>
        {(isAdmin === true && pdfName !== null && pdfName !== undefined && isEditState === true)
          ? (
            <button type="button"
                    className="shipment-button form-button form-input-shadow"
                    onClick={() => {
                      downloadPDF();
                    }}>
              {shipmentRequestLoading && (
              <i className="fa fa-refresh fa-spin"
                 style={{ marginRight: '5px' }} />
              )}
              <span>{pdfDownloadBtnTitle}</span>
            </button>
          ) : ''}
      </span>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(InstallationServiceSearchButtonAndPdfButton);



// WEBPACK FOOTER //
// ./src/views/InstallationServiceSearchButtonAndPdfButton.js